<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *ngIf="dynamicLoyaltyFeeds$ | async as dynamicFeeds">
    <div class="feed-container mb-4" *ngIf="dynamicFeeds.length > 0">
      <div class="feed-horizontal-container bg-dynamic-feed">
        <div class="container">
          <div class="dynamic-feed-wrapper" #container>
            <div class="action-wrapper" *ngIf="dynamicFeeds.length > 1">
              <div class="d-flex dots-carousel-mobile" [class.d-none]="isVertical">
                <ng-container *ngTemplateOutlet="dotsTemplate"></ng-container>
              </div>
              <button
                class="dynamic-layout-btn d-lg-none d-flex"
                [class.dynamic-layout-btn-vertical]="isVertical"
                (click)="toggleLayout()"
              >
                <span class="material-symbols-outlined">{{ isVertical ? 'hide' : 'pan_zoom' }}</span>
              </button>
            </div>
            <div class="dynamic-feed-list" #list fgbLazyLoad [class.vertical]="isVertical">
              <fgbcl-loyalty-feed-item
                *ngFor="let item of dynamicFeeds"
                [feed]="item"
                class="loyalty-feed-item"
                fgbLazyLoadItem
              ></fgbcl-loyalty-feed-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #dotsTemplate>
  <div class="carousel-dots" @popFade [class.d-none]="!showDots">
    <div class="dot-progress-bar">
      <div class="dot-progress" [style.width.%]="dotProgress"></div>
    </div>
    <div class="dot-circle" [class.active]="dots?.length > 0 && currentIndex >= dots.length - 2"></div>
    <div class="dot-circle" [class.active]="dots?.length > 0 && currentIndex === dots.length - 1"></div>
  </div>
</ng-template>
